/**
 * Ancre « avis » : tout élément portant data-avis-target="<id>" ouvre la cible si c'est un
 * <details> (l'accordéon avis), puis scrolle dessus. Ordinateur ET mobile.
 *
 * Utilisé par :
 *   - blocks/max-title-review.liquid  (les étoiles + le compteur, au-dessus du titre produit)
 *   - sections/max-avis-client.liquid (le bouton « Lire les avis »)
 *
 * Pourquoi un asset et plus un <script> inline dans max-title-review : le listener y était
 * enfermé, donc le bouton de max-avis-client aurait dépendu de la présence du block des
 * étoiles sur la page. En retirant ce block, le bouton serait retombé sur son href="#..."
 * -> saut brut, sans ouvrir l'accordéon, et sans le moindre message. Chaque fichier charge
 * désormais l'ancre lui-même.
 *
 * Délégué sur `document` : marche pour les éléments ajoutés après coup (éditeur de thème).
 * La garde évite un double listener si les deux fichiers sont sur la même page.
 */
if (!window.__maxAvisAnchor) {
  window.__maxAvisAnchor = true;

  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-avis-target]');
    if (!link) return;

    const target = document.getElementById(link.getAttribute('data-avis-target'));
    // Cible absente (ex. le titre de l'accordéon « Avis » a été vidé) : on laisse le
    // navigateur suivre le href plutôt que d'avaler le clic sans rien faire.
    if (!target) return;

    event.preventDefault();
    if (target.tagName === 'DETAILS') target.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
